import React, { memo, useMemo, useCallback } from "react";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';

const QuillMC = ({
  name = '',
  theme = 'snow',
  value = '',
  onChange,
  placeholder = '',
  className = '',
  style = { height: '300px' }
}) => {
  const handleChange = useCallback(
    (newValue) => {
      onChange?.(newValue);
    },
    [onChange]
  );

  const modules = useMemo(
    () => ({
      toolbar: [
        [{ header: [1, 2, false] }],
        ['bold', 'italic', 'underline'],
        [{ list: 'bullet' }, { list: 'ordered' }]
      ]
    }),
    []
  );

  const editorStyle = useMemo(
    () => style,
    [style]
  );

  return (
    <div className={`tw-flex tw-flex-col ${className}`}>
      <ReactQuill
        name={name}
        theme={theme}
        value={value || ''}
        onChange={handleChange}
        placeholder={placeholder}
        style={editorStyle}
        modules={modules}
      />
    </div>
  );
};

export default memo(QuillMC);
